/**
 * Types of existing locales for bryntum LocaleManager
 */
export enum LocaleType {
  Gb = 'gb',
  En = 'en',
  SvSE = 'svse'
}
